import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { ServiceType, ServiceDate, Addon, Confirm } from '@containers/booking';
import { Box } from '@components/common';
import BookingActions, { BookingSelectors } from '@redux/BookingRedux';
import ScheduleActions from '@redux/ScheduleRedux';
import { AuthSelectors } from '@redux/AuthRedux';
import { CleansSelectors } from '@redux/CleansRedux';
import history from '@utils/history';
import { BOOKING_STAGE } from '@services/minte';

function CleanReschedule(props) {
  const {
    initBooking,
    initialStep,
    initialChanges,
    bookingStep,
    goToStep,
    resetBooking,
    currentClean
  } = props;

  const goToNextStep = (priceChange = false) => {
    switch (bookingStep) {
      case BOOKING_STAGE.SERVICE_TYPE:
        goToStep(BOOKING_STAGE.ADDON);
        break;
      case BOOKING_STAGE.ADDON:
        goToStep(BOOKING_STAGE.CONFIRM);
        break;
      case BOOKING_STAGE.SERVICE_DATE:
        if (priceChange) {
          goToStep(BOOKING_STAGE.CONFIRM);
        } else {
          history.goBack();
        }
        break;
      case BOOKING_STAGE.CONFIRM:
        history.goBack();
    }
  };

  const renderContent = () => {
    switch (bookingStep) {
      case BOOKING_STAGE.RECIPIENT:
      case BOOKING_STAGE.FREQUENCY:
      case BOOKING_STAGE.SERVICE_TYPE:
        return <ServiceType onSubmit={goToNextStep} />;
      case BOOKING_STAGE.SERVICE_DATE:
        return <ServiceDate onSubmit={goToNextStep} isModifying />;
      case BOOKING_STAGE.ADDON:
        return <Addon onSubmit={goToNextStep} />;
      case BOOKING_STAGE.CONFIRM:
        return <Confirm onSubmit={goToNextStep} />;
    }
    return null;
  };

  function fetch() {
    initBooking(currentClean, initialStep, initialChanges);
  }

  useEffect(() => {
    fetch();
    return () => {
      resetBooking();
    };
  }, []);

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      flex={1}
      width={1}
    >
      {renderContent()}
    </Box>
  );
}

CleanReschedule.propTypes = {
  initialStep: PropTypes.string,
  initialChanges: PropTypes.any,
  bookingStep: PropTypes.string,
  currentClean: PropTypes.object,
  resetBooking: PropTypes.func.isRequired,
  initBooking: PropTypes.func.isRequired,
  goToStep: PropTypes.func.isRequired,
  selectedFrequency: PropTypes.string,
  isPMUser: PropTypes.bool
};

const mapStatesToProps = state => ({
  selectedFrequency: BookingSelectors.selectFrequency(state),
  bookingStep: BookingSelectors.selectCurrentStep(state),
  isPMUser: AuthSelectors.selectIsPMUser(state),
  currentClean: CleansSelectors.selectCurrentClean(state),
  initialStep: CleansSelectors.selectCleanEditing(state),
  initialChanges: CleansSelectors.selectCleanEditData(state)
});

const mapDispatchToProps = dispatch => ({
  initBooking: (clean, step, initialChanges) =>
    dispatch(BookingActions.initBookingFromClean(clean, step, initialChanges)),
  resetBooking: () => {
    dispatch(BookingActions.resetBooking());
    dispatch(ScheduleActions.resetRecurringBooking());
  },
  goToStep: step => dispatch(BookingActions.setBookingStep(step))
});

export default connect(
  mapStatesToProps,
  mapDispatchToProps
)(CleanReschedule);
